@use 'src/global/variables' as var;

c-form-table {
    /* rounded corners */
    .rounded {
        --radius: 10px;
        --border-color: black;
        border: 2px solid var(--border-color);
        border-radius: var(--radius);
        border-spacing: 0;
    }
    .rounded tr:first-child>:first-child { border-top-left-radius: var(--radius); }
    .rounded tr:first-child>:last-child { border-top-right-radius: var(--radius); }
    .rounded tr:last-child>:first-child { border-bottom-left-radius: var(--radius); }
    .rounded tr:last-child>:last-child { border-bottom-right-radius: var(--radius); }

    /* design */
    .rounded td {
        padding: 10px;
        /* border: 1px solid var(--border-color); */
        box-shadow: -2px -2px var(--border-color);
    }


    table {
        background: white;
    }

    table {
        width: 90%;
        margin-left: 5% !important;
        margin-bottom: 25px !important;

        tr, td {
          padding: 10px;
        }
    }
}